import AppFooter from './AppFooter.vue';

export { AppFooter };
export default AppFooter;
